import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { Table, Radio, Divider, Pagination } from "antd";
import { AppNotificationColumns } from "./AppNotificationColumns.js";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import Endpoints from "../../../api/endpoints.js";
import useSuccessErrorModal from "../../../hooks/successErrorModal/useSuccessErrorModal";
import routes from "../../../utils/routes.js";
import EndpointFunctions from "../../../utils/Functions/endpointFunctions.js";

const activeOrAllAppNotifications = [
  {
    label: "Tüm Uygulama Bildirimleri",
    value: Endpoints.getAllAppNotifications,
  },
];

const AppNotifications = () => {
  const { showModal, closeModal, ModalComponent } = useSuccessErrorModal();

  const [tableData, setTableData] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [radioValue, setRadioValue] = useState(
    Endpoints.getAllAppNotifications
  );
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    sortField: "id",
    sortDirection: "desc",
  });
  const [sorter, setSorter] = useState({
    sortField: "id",
    sortDirection: "desc",
  });

  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  useEffect(() => {
    fetchAppNotificationData({ endpoint: radioValue });
  }, [radioValue, pagination.current, pagination.pageSize, sorter]);

  const handleRadioChange = ({ target: { value } }) => {
    setRadioValue(value);
  };

  const fetchAppNotificationData = async ({ endpoint }) => {
    setTableLoading(true);

    const httpParams = {
      page: pagination.current - 1,
      size: pagination.pageSize,
      sortField: sorter.sortField,
      sortDirection: sorter.sortDirection,
    };

    const result = await EndpointFunctions.fetchData({
      endpointURL: endpoint,
      axiosPrivate: axiosPrivate,
      httpParams: httpParams,
    });

    if (result.success) {
      const paginationResult = result.data;
      const formattedData = result.data.data;
      setTableData(formattedData);
      setPagination({ ...pagination, total: paginationResult.total });
      setTableLoading(false);
    } else {
      setTableLoading(false);
      showModal(result.errorTitle, result.errorMessage, () => {
        closeModal();
      });
    }
  };

  const paginationChange = (page, pageSize) => {
    setPagination({ ...pagination, current: page, pageSize: pageSize });
  };

  const handleTableChange = (pagination, filters, sorter, extra) => {
    setSorter({
      sortField: sorter.field,
      sortDirection: sorter.order === "descend" ? "desc" : "asc",
    });
  };

  const goToDetailsPage = ({ record }) => {
    /* const id = record.id;
    let path = `${PageRoutes.updateVehicle}/${id}`;
    navigate(path); */
  };

  return (
    <>
      <Radio.Group
        options={activeOrAllAppNotifications}
        onChange={handleRadioChange}
        value={radioValue}
      />
      <div style={{ height: 20 }} />
      <Table
        dataSource={tableData}
        columns={AppNotificationColumns(goToDetailsPage)}
        scroll={{ x: true }}
        loading={tableLoading}
        pagination={false}
        onChange={handleTableChange}
        tableLayout="fixed" // Sütunların genişliklerini kontrol etmek için
      />
      <ModalComponent></ModalComponent>

      <Divider></Divider>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Pagination
          onChange={paginationChange}
          showSizeChanger
          total={pagination.total}
          showTotal={(total, range) =>
            `${range[0]}-${range[1]} of ${total} items`
          }
          pageSize={pagination.pageSize}
        />
      </div>
    </>
  );
};

export default AppNotifications;
